/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.learning.center.playlists.rpc.PlaylistChirpService
 */

/**
 *  This class can be used as a response type in cases where no response is needed or
 *  where <code>void</code> might have been used in a REST-ful context.
 */

export const createPlaylistRpc = {
  serviceName: 'com.hubspot.learning.center.playlists.rpc.PlaylistChirpService',
  rpcName: 'createPlaylist',
  auth: 'app',
  fingerprint: 'nyWalNbpZXMBeq-V2e5epImPIruyndla',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const updatePlaylistRpc = {
  serviceName: 'com.hubspot.learning.center.playlists.rpc.PlaylistChirpService',
  rpcName: 'updatePlaylist',
  auth: 'app',
  fingerprint: 'H7h2HtKcO84Beq-V2e5epImPIruyndla',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getPlaylistByIdRpc = {
  serviceName: 'com.hubspot.learning.center.playlists.rpc.PlaylistChirpService',
  rpcName: 'getPlaylistById',
  auth: 'app',
  fingerprint: '-CWYlUvyTZUBeq-V2e5epImPIruyndla',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const addPlaylistItemRpc = {
  serviceName: 'com.hubspot.learning.center.playlists.rpc.PlaylistChirpService',
  rpcName: 'addPlaylistItem',
  auth: 'app',
  fingerprint: 'ibll9NoUciEBeq-V2e5epImPIruyndla',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const deletePlaylistItemRpc = {
  serviceName: 'com.hubspot.learning.center.playlists.rpc.PlaylistChirpService',
  rpcName: 'deletePlaylistItem',
  auth: 'app',
  fingerprint: 'hVKdWkr9LNABeq-V2e5epImPIruyndla',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const savePlaylistRpc = {
  serviceName: 'com.hubspot.learning.center.playlists.rpc.PlaylistChirpService',
  rpcName: 'savePlaylist',
  auth: 'app',
  fingerprint: 'L7cV7et0ugSOUe2e_r4XmYmPIruyndla',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const unsavePlaylistRpc = {
  serviceName: 'com.hubspot.learning.center.playlists.rpc.PlaylistChirpService',
  rpcName: 'unsavePlaylist',
  auth: 'app',
  fingerprint: 'L7cV7et0ugSOUe2e_r4XmYmPIruyndla',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const searchRpc = {
  serviceName: 'com.hubspot.learning.center.playlists.rpc.PlaylistChirpService',
  rpcName: 'search',
  auth: 'app',
  fingerprint: 'LLPvPFYu5ZUdDFwNyJxsyYmPIruyndla',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getPlaylistSuggestionsRpc = {
  serviceName: 'com.hubspot.learning.center.playlists.rpc.PlaylistChirpService',
  rpcName: 'getPlaylistSuggestions',
  auth: 'app',
  fingerprint: 'HJ9gH5C05Rw8Zsr_dfBSM4mPIruyndla',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getPlaylistSuggestionsByDraftItemsRpc = {
  serviceName: 'com.hubspot.learning.center.playlists.rpc.PlaylistChirpService',
  rpcName: 'getPlaylistSuggestionsByDraftItems',
  auth: 'app',
  fingerprint: '6TljBz1MaDE8Zsr_dfBSM4mPIruyndla',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};